<template>
  <div class="modal modal-escrever-depoimentos" id="modal-escrever-depoimentos">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" id="modal-escrever-content">
        <div class="modal-header">
          <h4 class="modal-title">
            Você também pode contar
            <br />a sua história com a BP
          </h4>
          <p>Preencha os campos abaixo e nos envie sua história.</p>
          <button
            type="button"
            data-target="#modal-escrever-depoimentos"
            class="close"
            data-dismiss="modal"
          ></button>
        </div>

        <div class="cropper-stage" v-if="showCropper">
          <cropper
            class="cropper"
            :src="form.image"
            :stencil-props="{
              handlers: {},
              aspectRatio: 1,
              movable: true,
              scalable: false,
            }"
            :max-height="600"
            :max-width="600"
            ref="cropper"
          ></cropper>
          <div class="btn-group">
            <button class="btn btn-default btn-crop" @click="cancelCrop">Cancelar</button>
            <button class="btn btn-primary btn-crop" @click="cropImage">Cortar</button>
          </div>
        </div>
        <div class="loading" v-if="loading">
          <div class="lds-vue">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="sucesso" v-if="sucesso">
          <p>Muito obrigado! Seu envio foi realizado com sucesso e está em análise.</p>
        </div>
        <form method="post" @submit="submitForm" v-if="exibirFormulario()" novalidate>  
          <div class="modal-body">
            <div class="foto col-md-5" @dragover.prevent @drop="onDrop">
              <input
                style="display:none;"
                id="file-upload"
                type="file"
                name="image"
                accept="image/*"
                capture
                @change="fileChange($event)"
              />
              <label for="file-upload" class="descricao">
                <div v-if="!image">
                  <img class="camera" src="/images/retomada/photo-camera.svg" alt="Câmera" />
                  <strong>
                    Arraste e solte ou
                    <br />
                    <span>clique</span> e
                    <br />selecione a imagem
                  </strong>
                  <p>envie imagens até 5mb</p>
                </div>
                <img class="camera" :src="image" v-if="image" alt="Câmera" />
              </label>
            </div>
            <div class="direita col-md-7">
              <div class="form-group row">
                <input
                  style="display:none;"
                  type="text"
                  v-model="image"
                  name="image"
                  required
                  data-error-required="Campo 'Foto' é obrigatório."
                />
                <label for>Qual seu nome completo?</label>
                <input
                  id="fullName"
                  v-model="form.fullName"
                  name="fullName"
                  type="text"
                  value
                  class="form-control"
                  placeholder="Digite aqui seu nome completo"
                  required
                  data-error-required="Campo 'Nome Completo' é obrigatório"
                />
              </div>

              <div class="form-group row">
                <label for>Informe o seu e-mail</label>
                <input
                  id="email"
                  v-model="form.email"
                  name="email"
                  type="text"
                  value
                  class="form-control"
                  placeholder="Digite aqui o seu e-mail"
                  data-error-required="Campo 'E-mail' é obrigatório"
                  data-error-invalid="Campo 'E-mail' está invalido"
                  pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                  required
                />
              </div>

              <div class="form-group row">
                <label for>
                  Agora, nos conte como foi
                  <br />sua história com a BP
                </label>
                <textarea
                  id="testimony"
                  name="testimony"
                  v-model="form.testimony"
                  class="form-control"
                  required
                  placeholder="Escreva aqui sua história."
                  data-error-required="Campo 'Depoimento' é obrigatório"
                  maxlength="1500"
                ></textarea>
                <span class="char_count">{{ form.testimony.length + " de 1500 letras" }}</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="errors.length > 0">
            <div class="col-md-7 offset-md-5">
              <div class="form-group">
                <ul class="text-danger">
                  <li v-for="error in errors" v-bind:key="error.message">{{ error.message }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <div>
              <input
                v-model="form.aceiteTermo"
                type="checkbox"
                id="termos"
                name="termo"
                value="Eu aceito os termos de uso da minha imagem e depoimento."
              />
              <label for="termos">
                Eu aceito os
                <a data-toggle="modal" data-target="#modal-termos">
                  termos de
                  uso
                </a> da minha imagem e depoimento.
              </label>
            </div>
            <div>
              <button type="submit" class="botao-seta">
                Enviar
                <i></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import axios from "axios";
export default {
  name: "TestimonyForm",
  components: {
    Cropper
  },
  data() {
    return {
      showCropper: false,
      form: {
        image: "",
        fullName: "",
        email: "",
        testimony: "",
        aceiteTermo: false
      },
      image: null,
      coordinates: {
        width: 600,
        height: 600,
        left: 0,
        top: 0
      },
      errors: [],
      sucesso: false,
      loading: false
    };
  },
  methods: {
    pixelsRestriction({
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      imageWidth,
      imageHeight
    }) {
      return {
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
      };
    },
    onDrop: function(e) {
      e.preventDefault();
      this.fileChange(e);
    },
    submitForm(e) {
      const _scope = this;
      _scope.errors = [];
      let isValid = function() {
        return _scope.errors.length == 0;
      };

      let validateRequired = function(input, value) {
        let required = input.required;
        if (required && value == "") {
          var o = {};
          o["message"] = input.getAttribute("data-error-required");
          _scope.errors.push(o);
        }
      };

      let validatePattern = function(input, value, pattern) {
        let required = input.required;
        if (required && value != "") {
          var rgx = new RegExp(pattern);
          if (!rgx.test(value)) {
            var o = {};
            o["message"] = input.getAttribute("data-error-invalid");
            _scope.errors.push(o);
          }
        }
      };

      for (var input of e.target) {
        e.preventDefault();
        let type = input.type;
        let value = input.value;
        let pattern = input.pattern;
        if (type == "text" || type == "textarea") {
          validateRequired(input, value);
          validatePattern(input, value, pattern);
        }
      }

      if (!_scope.form.aceiteTermo) {
        _scope.errors.push({ message: "O Aceite do termo é obrigatório" });
      }

      if (isValid()) {
        var formBody = new FormData();
        formBody.append("nome", this.form.fullName);
        formBody.append("email", this.form.email);
        formBody.append("depoimento", this.form.testimony);
        formBody.append("campanha", "Retomada");
        formBody.append("foto", this.image);
        formBody.append("midia", "");
        _scope.loading = true;
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios
          .post("/umbraco/surface/depoimento/send", formBody, {
            headers: {
              Accept: "",
              "Content-Type": "application/json;charset=utf-8"
            }
          })
          .then(function(response) {
            console.log(response);
            _scope.sucesso = true;
            _scope.loading = false;
          });
      }
    },
    fileChange(e) {
      var _scope = this;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }

      for (let i = 0; i <= files.length - 1; i++) {
        let fsize = files.item(i).size;
        let file = Math.round(fsize / 1024);
        if (file >= 5120) {
          alert(
            "Arquivo grande, por favor escolha uma imagem com peso menor 5mb"
          );
          return;
        }
      }

      var reader = new FileReader();
      reader.addEventListener("load", function(e) {
        var result = e.target.result;
        _scope.showCropper = true;
        _scope.form.image = result;
        _scope.$refs.cropper.replace(result);
      });
      reader.readAsDataURL(files[0]);
    },
    change({ coordinates, canvas }) {
      console.log(coordinates, canvas);
    },
    cancelCrop() {
      this.showCropper = false;
      this.form.image = "";
    },
    cropImage() {
      console.log(this.$refs);
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image
      var resizedCanvasEl = document.createElement("canvas");
      var resizedCanvas = resizedCanvasEl.getContext("2d");

      resizedCanvasEl.width = 600;
      resizedCanvasEl.height = 600;

      resizedCanvas.drawImage(canvas, 0, 0, 600, 600);

      this.image = resizedCanvasEl.toDataURL("image/jpeg", 0.7);
      this.cancelCrop();
    },
    exibirFormulario() {
      if (this.loading) {
        return false;
      }
      if (this.sucesso) {
        return false;
      }
      if (this.showCropper) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>
.cropper-app {
  position: relative;
}
.cropper-stage {
}
.cropper-preview {
  max-width: 80%;
}

.uploader {
  display: block;
  clear: both;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
}
.uploader label {
  float: left;
  clear: both;
  width: 100%;
  padding: 2rem 2rem;

  text-align: center;
  background: #fff;
  border-radius: 7px;
  border: 3px solid #eee;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.uploader label:hover {
  border-color: #454cad;
}
.uploader label.hover {
  border: 3px solid #454cad;
  box-shadow: inset 0 0 0 6px #eee;
}
.uploader label.hover #start i.fa {
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
  opacity: 0.3;
}
.uploader #start {
  float: left;
  clear: both;
  width: 100%;
}
.uploader #start.hidden {
  display: none;
}
.uploader #start i.fa {
  font-size: 50px;
  margin-bottom: 1rem;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.uploader #response {
  float: left;
  clear: both;
  width: 100%;
}
.uploader #response.hidden {
  display: none;
}
.uploader #response #messages {
  margin-bottom: 0.5rem;
}
.uploader #file-image {
  display: inline;
  margin: 0 auto 0.5rem auto;
  width: auto;
  height: auto;
  max-width: 180px;
}
.uploader #file-image.hidden {
  display: none;
}
.uploader #notimage {
  display: block;
  float: left;
  clear: both;
  width: 100%;
}
.uploader #notimage.hidden {
  display: none;
}
.uploader progress,
.uploader .progress {
  display: inline;
  clear: both;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  height: 8px;
  border: 0;
  border-radius: 4px;
  background-color: #eee;
  overflow: hidden;
}
.uploader .progress[value]::-webkit-progress-bar {
  border-radius: 4px;
  background-color: #eee;
}
.uploader .progress[value]::-webkit-progress-value {
  background: -webkit-linear-gradient(left, #393f90 0%, #454cad 50%);
  background: linear-gradient(to right, #393f90 0%, #454cad 50%);
  border-radius: 4px;
}
.uploader .progress[value]::-moz-progress-bar {
  background: linear-gradient(to right, #393f90 0%, #454cad 50%);
  border-radius: 4px;
}
.uploader input[type="file"] {
  display: none;
}
.uploader div {
  margin: 0 0 0.5rem 0;
  color: #5f6982;
}
.uploader .btn {
  display: inline-block;
  margin: 0.5rem 0.5rem 1rem 0.5rem;
  clear: both;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  text-transform: initial;
  border: none;
  border-radius: 0.2rem;
  outline: none;
  padding: 0 1rem;
  height: 36px;
  line-height: 36px;
  color: #fff;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  background: #454cad;
  border-color: #454cad;
  cursor: pointer;
}

.cropper {
  background: #ddd;
}

.vue-advanced-cropper{
  max-height: 400px;
}

.char_count{
  font-size:12px;
  color:#707070;
}
</style>